

<div class="docViewver">
    <button (click)="onClickOpen()" title="Vorschau" *ngIf="isToShow && !smallBtn" class="btn btn-sm btn-success">Vorschau</button>
    <button (click)="onClickOpen()" title="Vorschau" *ngIf="isToShow && smallBtn" class="btn btn-xs btn-success"><span class="glyphicon glyphicon-eye-open"></span></button>
</div>


<dx-popup class="popup"
          *ngIf="isToShow"
          [showTitle]="true"
          title="Dokumentenvorschau"
          [height]="'90%'"
          [width]="'80%'"
          [dragEnabled]="false"
          [hideOnOutsideClick]="false"
          (onHidden)="onHiddenPopup($event)"
          [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <cz-document-viewer *ngIf="popupVisible" [fileName]="fileName"></cz-document-viewer>
  </div>

  <dxi-popup-toolbar-item widget="dxButton"
                    location="after"
                    toolbar="bottom"
                    [options]="{
            text: 'Ok',
            onClick: hidePopup
        }">
  </dxi-popup-toolbar-item>

</dx-popup>
